import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Alert, App, Form, Input, Modal } from 'antd'
import { useTRPC } from '@/trpc/react.ts'

export function RentalArchiveModal({ rentalOrderId, onClose }: { rentalOrderId: number; onClose: () => void }) {
  const [open, setOpen] = useState(true)
  const [reason, setReason] = useState('')
  const trpc = useTRPC()
  const cache = useQueryClient()
  const { message } = App.useApp()
  const archive = useMutation(trpc.order.rental.archive.mutationOptions())
  return (
    <Modal
      open={open}
      title="归档租赁订单"
      onCancel={() => setOpen(false)}
      afterClose={onClose}
      confirmLoading={archive.isPending}
      closable={!archive.isPending}
      keyboard={!archive.isPending}
      mask={{ closable: false }}
      cancelButtonProps={{ disabled: archive.isPending }}
      okText="确认归档"
      okButtonProps={{ disabled: !reason.trim() }}
      onOk={async () => {
        try {
          await archive.mutateAsync({ rentalOrderId, reason })
          await Promise.all([
            cache.invalidateQueries(trpc.order.rental.detail.queryFilter({ rentalOrderId })),
            cache.invalidateQueries(trpc.order.rental.list.queryFilter())
          ])
          void message.success('已归档，可在列表按“已归档”筛选查看')
          setOpen(false)
        } catch (error) {
          void message.error(error instanceof Error ? error.message : '归档失败')
        }
      }}
    >
      <Alert
        className="mb-4!"
        showIcon
        type="info"
        title="标记资料收尾，保留历史记录"
        description="归档后移出默认列表，记录归档时间并保留原业务状态；可通过“归档状态”筛选查看。归档不会核销欠款、退款或释放空间，后续仍可处理账务及补充备注附件。"
      />
      <Form layout="vertical" disabled={archive.isPending}>
        <Form.Item label="归档原因" required>
          <Input.TextArea
            aria-label="归档原因"
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            maxLength={5000}
            rows={3}
            placeholder="例如：租赁已结束，合同与交接资料已整理完成"
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
